import { matchingEngineApi } from '../matching-engine.utils';
import { UseMutationOptions } from 'react-query';
import { useMutation } from 'common/hooks';
import { VoteType } from '../matching-engine.utils';

type AddSkillFeedbackParams = {
  revieweeId: string;
  skillId: string;
  feedback: string;
  voteType: VoteType;
};

export const useAddSkillFeedback = (options: UseMutationOptions = {}) => {
  const addSkillFeedbackApi = (feedback: AddSkillFeedbackParams) => {
    return matchingEngineApi.post('add-skill-feedback', { ...feedback });
  };
  return useMutation(addSkillFeedbackApi, {
    showSuccessSnackbar: true,
    ...options,
  });
};
